import { render, staticRenderFns } from "./SidebarToggle.vue?vue&type=template&id=68fb5d14&scoped=true&"
import script from "./SidebarToggle.vue?vue&type=script&lang=js&"
export * from "./SidebarToggle.vue?vue&type=script&lang=js&"
import style0 from "./SidebarToggle.vue?vue&type=style&index=0&id=68fb5d14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fb5d14",
  null
  
)

component.options.__file = "SidebarToggle.vue"
export default component.exports